import { getHotpanelEndpointProvider, getHotpanelEndpointUrl, HotpanelApi } from '@bumble/hotpanel';
import sendRequest from '@bumble/hotpanel/transport/send-request-browser';
import { Brand, Layout, Platform as HotpanelPlatform } from '@bumble/proto/hotpanel';
import { Startup } from 'lib/api/startup';
import { GlobalProps } from 'lib/app/global-props';
import { Platform } from 'lib/app/platform';
import { getHotpanelSession } from 'lib/app/hotpanel-session';
import { getDeviceId } from 'lib/app/device-id';
import { ProtoScreenNameEnum } from 'lib/proto-types';

const DEFAULT_LANGUAGE_CODE = __DEFAULT_LANG__;
const UNKNOWN_COUNTRY_ID = 0;

let globalProps: GlobalProps | undefined;
let startup: Startup | undefined;
let screenName: ProtoScreenNameEnum | undefined;

export const hotpanelApi = new HotpanelApi({
    getHotPanelConfig() {
        const hotpanelProvider = getHotpanelEndpointProvider(startup?.startup);
        return {
            url: hotpanelProvider?.url ? getHotpanelEndpointUrl(hotpanelProvider.url) : undefined,
            maximumPoolSize: hotpanelProvider?.maximumPoolSize
                ? hotpanelProvider.maximumPoolSize
                : 20,
            maximumTimeout: hotpanelProvider?.maximumTimeout
                ? hotpanelProvider.maximumTimeout * 1000
                : 3000,
        };
    },

    getRequestBody() {
        return {
            application: {
                brand: Brand.BRAND_BADOO,
                layout: getLayout(globalProps?.platform),
                platform: getPlatform(globalProps?.platform),
                app_version: globalProps?.appVersion || '1.0.00',
                is_premium: false,
            },
            device: {
                locale: globalProps?.lang || DEFAULT_LANGUAGE_CODE,
                device_id: getDeviceId(),
                user_agent: {
                    ua: window.navigator.userAgent,
                },
            },
            user: {
                country_id: startup?.commonSettings?.user_country?.id || UNKNOWN_COUNTRY_ID,
            },
            session_id: getHotpanelSession(globalProps?.platform),
        };
    },

    getEventTrackingInfo() {
        return screenName !== undefined
            ? {
                  screen_name: screenName,
                  screen_id: '0',
              }
            : undefined;
    },

    sendRequest,
});

function getLayout(platform: Platform | undefined) {
    if (platform === Platform.DESKTOP_WEB) {
        return Layout.LAYOUT_PC;
    }

    return Layout.LAYOUT_PHONE;
}

function getPlatform(platform: Platform | undefined) {
    if (platform === Platform.DESKTOP_WEB) {
        return HotpanelPlatform.PLATFORM_WEB;
    }

    return HotpanelPlatform.PLATFORM_MOBILE_WEB;
}

export function setStartup(startupResponse: Startup) {
    startup = startupResponse;
}

export function setGlobalProps(props: GlobalProps) {
    globalProps = props;
}

export function setScreenName(screen: ProtoScreenNameEnum | undefined) {
    screenName = screen;
}

export { HotpanelApi };
